<template>
  <div v-if="stripeCustomCheckoutSession" class="text-sm mt-10 text-dark-900">
    <!-- If Trial -->
    <template v-if="isTrial">
      <div class="p-4 border border-dark-100 shadow-sm rounded bg-dark-50/50">
        <p class="block text-sm mb-1.5 font-bold">
          {{ stripeCustomCheckoutSession.recurring?.trial.trialPeriodDays }} DAYS FREE TRIAL
        </p>
        <p class="block text-xs text-dark-800 mb-4">
          Afterwards {{ formatCurrency(stripeCustomCheckoutSession.recurring.dueNext.amountSubtotal - stripeCustomCheckoutSession.recurring.dueNext.amountDiscount, stripeCustomCheckoutSession.currency) }} per {{ stripeCustomCheckoutSession.recurring.interval }} (cancel anytime) if you don’t cancel within trial
        </p>
        <div class="h-[1px] my-2 bg-dark-100 block" />
        <div class="flex items-center py-1 block text-sm font-bold">
          <span>Today</span>
          <span class="ml-auto">
            {{ formatCurrency(stripeCustomCheckoutSession.total.total, stripeCustomCheckoutSession.currency) }}
          </span>
        </div>
      </div>
    </template>

    <!-- Else -->
    <template v-else>
      <div class="p-4 border border-dark-100 shadow-sm rounded bg-dark-50/50">
        <div class="flex items-center py-1">
          <span>Subtotal</span>
          <span class="ml-auto">{{ formatCurrency(stripeCustomCheckoutSession.total.subtotal, stripeCustomCheckoutSession.currency) }}</span>
        </div>

        <slot name="promo-code" />

        <div class="flex items-center py-1 text-dark-800">
          <span>Tax</span>
          <span class="ml-auto">{{ formatCurrency(stripeCustomCheckoutSession.total.taxInclusive, stripeCustomCheckoutSession.currency) }}</span>
        </div>
        <div class="h-[1px] my-2 bg-dark-100" />
        <div class="flex items-center py-1 text-lg font-bold">
          <span>Total</span>
          <span class="ml-auto">
            {{ formatCurrency(stripeCustomCheckoutSession.total.total, stripeCustomCheckoutSession.currency) }}
            <template v-if="stripeCustomCheckoutSession.recurring">
              <span class="text-sm font-normal text-dark-600"> / {{ stripeCustomCheckoutSession.recurring.interval }}</span>
            </template>
          </span>
        </div>
        <!-- On off payment -->
        <template v-if="!stripeCustomCheckoutSession.recurring">
          <p class="text-xs font-normal text-dark-600 ml-auto text-right">
            (one-off payment)
          </p>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type Stripe from '@stripe/stripe-js'

const props = defineProps<{
  stripeCustomCheckoutSession: Stripe.StripeCustomCheckoutSession | null
}>()

const isTrial = computed(() => !!props.stripeCustomCheckoutSession?.recurring?.trial)

function formatCurrency(value: number, currency: string) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value / 100)
}
</script>
